import { FC } from "react";

import { BentoElement, BentoElementType, BentoTextElement, EditorialModuleImage } from "@/types";

import TiledImageHorizontal from "../BentoList/TiledImageHorizontal";
import TiledText from "./TiledText";

const TiledBlockHWithImage: FC<{ items: BentoElement[] }> = ({ items }) => {
  return (
    <div className="grid grid-cols-2 gap-xs">
      {items.map((item, index) => (
        <>
          {item.type === BentoElementType.image ? (
            <TiledImageHorizontal entry={item as EditorialModuleImage}></TiledImageHorizontal>
          ) : (
            item.type === BentoElementType.text && <TiledText slideIndex={index} key={item.id} entry={item as BentoTextElement} />
          )}
        </>
      ))}
    </div>
  );
};
export default TiledBlockHWithImage;
